import getQueryUrl from '../utils/getQueryUrl';

// Initial State
const initialState = {
  problematicPharmacies: [],
  isLoading: false,
  totalPharmacies: 0,
  paymentMethods: [],
  isPaymentMethodsLoading: false,
};

// Action constants
const GET_PROBLEMATIC_PHARMACIES = 'GET_PROBLEMATIC_PHARMACIES';
const GET_PROBLEMATIC_PHARMACIES_SUCCESS = 'GET_PROBLEMATIC_PHARMACIES_SUCCESS';
const GET_PROBLEMATIC_PHARMACIES_FAILURE = 'GET_PROBLEMATIC_PHARMACIES_FAILURE';

const GET_PAYMENT_METHODS = 'GET_PAYMENT_METHODS';
const GET_PAYMENT_METHODS_SUCCESS = 'GET_PAYMENT_METHODS_SUCCESS';
const GET_PAYMENT_METHODS_FAILURE = 'GET_PAYMENT_METHODS_FAILURE';

// Action creators
export const getProblematicPharmacies = ({ pharmacyType, status, orderType, page = 0, limit = 10 }) => {
  const query = { pharmacy_type: pharmacyType, page, limit };

  if (status !== 'all') {
    query.status = status;
  }

  if (orderType) {
    query.order_type = orderType;
  }

  return {
    types: [
      GET_PROBLEMATIC_PHARMACIES,
      GET_PROBLEMATIC_PHARMACIES_SUCCESS,
      GET_PROBLEMATIC_PHARMACIES_FAILURE
    ],
    payload: {
      request: {
        url: getQueryUrl('/pharmacies/V2/problematic', query),
        method: 'GET',
      }
    }
  };
};

export const getPaymentMethods = () => {
  return {
    types: [GET_PAYMENT_METHODS, GET_PAYMENT_METHODS_SUCCESS, GET_PAYMENT_METHODS_FAILURE],
    payload: {
      request: {
        url: '/pharmacies/V2/payment-methods',
        method: 'GET',
      }
    }
  };
};

const problematicPharmaciesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROBLEMATIC_PHARMACIES:
      return {
        ...state,
        isLoading: true
      };

    case GET_PROBLEMATIC_PHARMACIES_FAILURE:
      return {
        ...state,
        isLoading: false
      };

    case GET_PROBLEMATIC_PHARMACIES_SUCCESS:
      return {
        ...state,
        problematicPharmacies: action.payload.data.data,
        totalPharmacies: action.payload.data.pagination?.count,
        isLoading: false
      };

    case GET_PAYMENT_METHODS:
      return {
        ...state,
        isPaymentMethodsLoading: true
      };

    case GET_PAYMENT_METHODS_SUCCESS:
      return {
        ...state,
        isPaymentMethodsLoading: false,
        paymentMethods: action.payload.data.data
      };

    case GET_PAYMENT_METHODS_FAILURE:
      return {
        ...state,
        isPaymentMethodsLoading: false,
        paymentMethods: []
      };

    default:
      return state;
  }
};

export default problematicPharmaciesReducer;
